<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VCheckEditor',
  extends: compoment
}
</script>
